import { Icon } from "@/components/icons/Icon";
import { useLanguage } from "@/context/language-context/LanguageContext";
import type { IQuestion } from "@/types/types";
import ModalEditQuestion from "../modal-edit-question/ModalEditQuestion";
import ModalRemoveQuestion from "../modal-remove-question/ModalRemoveQuestion";
import { useQuestionsForm } from "@/store/useQuestionsForm";
import { memo } from "react";

const QuesntionsBody = ({ questions }: { questions: IQuestion[] }) => {
  const { language } = useLanguage();
  const { isEditing } = useQuestionsForm();

  return questions.length > 0 ? (
    questions.map((question, index: number) => {
      return (
        <tr
          data-testid={`checklist-body-row-${question.questionId}`}
          key={`checklist-row-${question.questionId}`}
          className={`${index % 2 === 0 ? "table-odd-row" : "table-even-row"}${
            index === questions.length - 1 ? " last-row" : ""
          } h-16 border-b border-b-ib-gray-lightest text-[14px] leading-[16px] text-ib-gray-darkest `}
        >
          <td className="p-3 text-center">{index + 1}</td>
          <td className="p-3 text-left">{question[language]}</td>
          <td className="p-3 text-center">
            <div className="flex items-center space-x-3">
              <Icon className="size-4" name="images" />
              <span>{question.images.length}</span>
            </div>
          </td>
          <td className="p-3 flex justify-end items-center">
            {isEditing && (
              <div className="flex space-x-6">
                <ModalEditQuestion question={question} />
                <ModalRemoveQuestion question={question} index={index + 1} />
              </div>
            )}
          </td>
        </tr>
      );
    })
  ) : (
    <></>
  );
};

export default memo(QuesntionsBody);
